module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.message) ? _c('div', {
    staticClass: "error-message-text"
  }, [_vm._v(" \n  " + _vm._s(_vm.message) + "\n")]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-73db5ffc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ErrorMessageBox.vue
// module id = 1034
// module chunks = 1